'use strict';


import map from './map';
import hint from './hint';


Vue.component('vue-map', map);
Vue.component('vue-map-hint', hint);


// ------------------------------


// Trigger / translator events for groups
Raphael.el.trigger = function (name, params) {
  this.events && this.events.forEach(function (event) {
    event.name === name && event.f.call(this, params);
  }, this);
};

// Trigger / translator of events for elements
Raphael.st.trigger = function (event, params) {
  this.forEach(function (elem) {
    elem.trigger(event, params);
  });
};


// WEBPACK FOOTER //
// ./src/js/index.js